import React from 'react';
import { Grid } from '@mui/material';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import BadgeIcon from '@mui/icons-material/Badge';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Section, InfoField } from '../ViewPatientDialog.utils';

export default function SoaTab({ patient }) {
  const fiche = patient?.fiche_patient;

  return (
    <>
      <Section icon={<DirectionsRunIcon />} title="Attentes et accompagnement SOA" subtitle="Besoins et attentes exprimés par le patient">
        <Grid container spacing={2}>
          <InfoField label="Attentes SOA" value={fiche?.attentes_soa} fullWidth multiline />
        </Grid>
      </Section>

      <Section icon={<BadgeIcon />} title="Situation financière" subtitle="Informations financières et notes associées">
        <Grid container spacing={2}>
          <InfoField label="Situation financière" value={fiche?.situation_financiere} fullWidth multiline />
          <InfoField label="Notes financières" value={fiche?.notes_financieres} fullWidth multiline />
        </Grid>
      </Section>

      <Section icon={<InfoOutlinedIcon />} title="Autres informations" subtitle="Informations complémentaires du dossier">
        <Grid container spacing={2}>
          <InfoField label="Autre information" value={fiche?.autre_info} fullWidth multiline />
        </Grid>
      </Section>
    </>
  );
}